import { performInMemorySearch } from '@/components/search/searchStore';
import { SYNC_STATES } from '@/store/sync/sync';
import MODULE_ID from './moduleId';
import weblinkApi from './weblinkApi';

const ROOT = { root: true };

const state = {
  weblinkItems: [],
  weblinkUserState: [],
  selectedLinkId: null,

  // view states
  currentWeblinkItem: null,

  dataLoaded: false,
};

const getters = {
  /** ------------------------------------------------------------------------------------------------------------------
   * Module Implementation for unread badge counts by instance.
   * IMPLEMENT this getter to enable unread counter badges
   * -------------------------------------------------------------------------------------------------------------------
   */
  getUnreadCountByModuleInstance: (state) => (instance) => {
    return 0;
  },
};

const mutations = {
  /**
   * ------------------------------------------------------------------------------------------------------------------
   * MANDATORY MODULE IMPLEMENTATION for UPDATING Module counters
   * ------------------------------------------------------------------------------------------------------------------ *
   */
  countModuleItems(state) {
    //Not necessary
  },

  setData(state, { weblinkItems, weblinkUserState }) {
    state.weblinkItems = weblinkItems;
    state.weblinkUserState = weblinkUserState;
    state.dataLoaded = true;
  },
  setSelectedLinkId(state, { id }) {
    state.selectedLinkId = id;
  },
  setCurrentWeblink(state, weblink) {
    state.currentWeblinkItem = weblink;
  },
};

const actions = {
  /**
   * ------------------------------------------------------------------------------------------------------------------
   * MANDATORY MODULE IMPLEMENTATION for IN-MEMORY SEARCH
   * IMPLEMENT this getter to enable module in-memory search
   * Call the action in search/searchStore (search for "Module in-memory searches" there)
   * Search all documents containing all of the space separated search words in state.filterCriteria
   * ------------------------------------------------------------------------------------------------------------------ *
   */
  searchModuleInMemoryContainingSearchTerm({ state }, { filterCriteria, options }) {
    //console.debug('searchModuleInMemoryContainingSearchTerm items', JSON.stringify(state.weblinkItems, null, 2), MODULE_ID);
    return performInMemorySearch({
      moduleId: MODULE_ID,
      items: state.weblinkItems,
      titleSearchAttr: 'title',
      contentSearchAttr: null,
      searchCriteriaArray: filterCriteria,
      options,
    });
  },

  /**
   * ------------------------------------------------------------------------------------------------------------------
   * MANDATORY MODULE IMPLEMENTATION
   * Updates the browsers cache storage oevpad-api/modules/{moduleId} with the exact same data structure as received by the module sync api call!
   * Reason: This mutation MUST be called whenever data has changed, e.g. user_state data. It assures that the application cache is up-to-date
   *         when the user synchronized/updates in offline mode.
   * ------------------------------------------------------------------------------------------------------------------
   */
  async updateModuleApplicationCache({ state }) {
    // const { weblinkItems } = state;
    // await updateModuleCache(moduleIndex.api, { weblinkItems });
  },

  /**
   * ------------------------------------------------------------------------------------------------------------------
   * MANDATORY MODULE IMPLEMENTATION to synchronize files
   * Dispatched in store/sync !!!
   * Synchronize module files, that is storing files into browsers application cache by simply loading files from server.
   * The service-worker will intercept all requests and put files into cache if not yet there.
   * ------------------------------------------------------------------------------------------------------------------
   */
  async synchronizeFiles({ commit, dispatch, state }) {
    // await cacheAllModuleFiles({ files: state.reports, moduleIndex, commit, dispatch });
    // No files to cache
  },

  /**
   * ------------------------------------------------------------------------------------------------------------------
   * MANDATORY MODULE IMPLEMENTATION to synchronize files
   * Dispatched in store/sync !!!
   * Synchronize module files, that is storing files into browsers application cache by simply loading files from server.
   * The service-worker will intercept all requests and put files into cache if not yet there.
   * ------------------------------------------------------------------------------------------------------------------
   */
  async synchronizeData({ commit, dispatch, rootState, rootGetters }) {
    try {
      const response = await weblinkApi.getData();

      let { weblinkItems, weblinkUserState } = response.data;

      commit('setData', { weblinkItems, weblinkUserState });
    } catch (err) {
      console.error(err);
      commit('sync/setSyncState', { moduleId: MODULE_ID, syncState: SYNC_STATES.FAILURE, msg: err }, ROOT);
      throw err;
    }
  },
  /**
   * ------------------------------------------------------------------------------------------------------------------
   * MANDATORY MODULE IMPLEMENTATION
   * Dispatched in store/sync !!!
   * Gets dispatched after all sync processes have been completed.
   * This is the place to implement any post sync processes.
   * ------------------------------------------------------------------------------------------------------------------
   */
  async onSyncComplete({ commit, dispatch, rootState, rootGetters }) {
    // Implement this method if necessary
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
